import React from 'react'
import {DatePicker, Form, Input, Select} from "antd";
import config from "../../../config";


const {Option} = Select
const {RangePicker} = DatePicker
const purchaseStatusSelect = [
    {value: true, label: 'TAMAMLANDI'},
    {value: false, label: 'BEKLİYOR'}
]

const PurchaseFilter = () => {

    return(
        <React.Fragment>
            <Form.Item
                name={'purchaseNo'}
                label={'Satın Alma No'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'stockCode'}
                label={'Stok Kodu'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'stockName'}
                label={'Stok Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'supplierName'}
                label={'Tedarikçi Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'whom'}
                label={'Kime'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'createdBy'}
                label={'Oluşturan'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'date'}
                label={'Satın Alma Tarihi'}
                initialValue={''}
            >
                <RangePicker format={config.userDateFormat} />
            </Form.Item>
            <Form.Item
                name={'completedPurchase'}
                label={'Satın Alma Durumu'}
            >
                <Select options={purchaseStatusSelect}>
                </Select>
            </Form.Item>
        </React.Fragment>
    )
}
export default PurchaseFilter